import UserManage from './UserManage';
import SystemManage from './SystemManage';
import AuditLog from './AuditLog';
import License from './License';

export default {
  UserManage,
  SystemManage,
  AuditLog,
  License,
};



// WEBPACK FOOTER //
// ./src/manage-modules/index.js